import { mailTypes } from "../constant/mailType";
import { Tooltip } from "antd";
import { useState, useRef, useEffect, memo } from "react";
import mail1 from "../assets/images/email.png";
import { PostCallWithErrorResponse } from "../Api/ApiServices";
import { ApiConfig } from "../Api/ApiConfig";
import { Modal, Form, Badge } from "react-bootstrap";
import { toastMsg } from "./toast";
import ReactQuill from "react-quill";


const MailBox = memo((props) => {

    let { type, selectsRec, code, selects, setSelectsRec, setSelects } = props

    const [open, setOpen] = useState(false);
    const [quillKey, setQuillKey] = useState(0);
    const dropdownRef = useRef(null);

    const [emailContentType, setEmailContentType] = useState(0)


    const [ccEmails, setCcEmails] = useState([]);

    const [mailKey, setMailKey] = useState(0)

    const [mailRecords, setMailRecords] = useState({
        all: 0,
        notInrsted: 0,
        sendTo: []
    })

    const [emailContent, setEmailContent] = useState("");
    const [showApplication, setShowApplication] = useState(null);

    const [from, setFrom] = useState("");

    const [subject, setSubject] = useState("");

    const [showMail, setShowmail] = useState(null);

    const [freq, setFreq] = useState(null);

    const [inputValue, setInputValue] = useState('')

    const [inputValueTest, setInputValueTest] = useState([]);

    const [toEmails, setToEmails] = useState([]);

    const removeEmailTest = (emailToRemove) => {
        setToEmails(toEmails.filter((x) => x != emailToRemove));
    };


    const [stop, setStop] = useState(null);
    const [stopby, setStopby] = useState(null);
    const [whatsAppRoundTwo, setWhatsAppRoundTwo] = useState(false);
    const [whatsAppRej, setWhatsAppRej] = useState(false);

    const [isDefaultEmailContent, setIsDefaultEmailContent] = useState(false)

    const [showRound2, setShowRound2] = useState(null);
    const [showMailTest, setShowMailTest] = useState(null);
    const [reject, setReject] = useState(null);

    const handleHideMailTest = () => {
        setShowMailTest(false);
    };




    const [whatsApp, setWhatsApp] = useState(false);

    const htmlContentData = (selReason, type = false) => {
        // console.log(code);

        PostCallWithErrorResponse(ApiConfig.GET_EMAIL_CONTENT, {
            codeid: code,
            reason: selReason,
            isDefault: type
        })
            .then((res) => {
                if (res) {
                    console.log(res);
                    setEmailContent(res?.json?.emailContent);
                    setSubject(res?.json?.subject);
                    setFrom(res?.json?.fromEmail);
                    setQuillKey(prev => prev + 1);
                } else {
                    console.log("err");
                }
            })
            .catch((err) => console.log(err));
    };

    const handleKeyDownTest = (e) => {
        if (e.key === "Enter" || e.key === ",") {
            e.preventDefault();
            const email = inputValueTest.trim();
            const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
            if (email && isValidEmail && !toEmails.includes(email)) {
                setToEmails((prevEmails) => [...prevEmails, email]);
            } else {
                toastMsg("error", "Please enter valid email Id");
            }
            setInputValueTest("");
        }
    };

    const handleSendEmailTest = (e) => {
        if (toEmails.length > 0) {
            const { name } = e.target;
            const payload = {
                fromEmail: from,
                htmlContent: emailContent,
                emails: toEmails,
                subject: subject,
            };
            handleHideMailTest();
            PostCallWithErrorResponse(ApiConfig.SEND_ASSESSMENT_REMINDER, payload)
                .then((res) => {
                    console.log(res);
                    if (res.json.status) {
                        toastMsg("success", res.json.statusMessage);
                        setToEmails([]);
                        // handleHideMail();
                        // handleHideApp();
                        // handleHideRound();

                        // setEmailContent("");

                        // handleHideMailTest();
                        // setSelectsRec([]);
                    } else {
                        toastMsg("error", res.json.statusMessage);
                    }
                })
                .catch((err) => console.log(err));
        } else {
            toastMsg("error", "Kindly add receiver email Id and press enter key");
        }
    };

    const handleHideReject = () => {
        setReject(false);
        // setHoverTrue(false);
        setCcEmails([]);
        setWhatsAppRej(false);
        setStop(null);
        setFreq(null);
        setStopby(null);
    };
    const handleShowMailTest = () => {
        setShowMailTest(true);
    };
    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === ",") {
            e.preventDefault();
            const email = inputValue.trim();
            const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
            if (email && isValidEmail && !ccEmails.includes(email)) {
                setCcEmails((prevEmails) => [...prevEmails, email]);
            } else {
                toastMsg("error", "Please enter valid email Id");
            }
            setInputValue("");
        }
    };

    const eclusionMails = (type) => {

        let all = selectsRec.length

        selectsRec = selectsRec?.filter((i) => i?.status !== "Not Interested")

        let message = ''
        let filt = []
        if (type === 1 || type == 4 || type === 5 || type == 6) {


            if (type === 1) {

                filt = selectsRec.filter((i) => i.percentage !== "100%")
                message = "Assesment"


            }



            if (type === 4) {

                filt = selectsRec.filter((i) => i.profileFilledPercentage !== "100%")
                message = "Application"
            }

            if (type === 5 || type === 6) {

                filt = selectsRec.filter((i) => i.profileFilledPercentage === "100%")
                message = "Application Not"

            }

        } else if (type === 2) {
            filt = selectsRec.filter((i) => i.quizScore === 'N/A')
            message = "Quiz"

        } else if (type === 3) {

            filt = selectsRec
        }

        setMailRecords(prev => ({
            ...prev,
            all: all,
            sendTo: filt,
            notInrsted: all - selectsRec.length,
            type: message
        }))
    }

    const handleHideApp = () => {
        setShowApplication(false);
        setCcEmails([]);
        setWhatsApp(false);
        setStop(null);
        setFreq(null);
        setStopby(null);
        setSubject("");
        setIsDefaultEmailContent(false)
    };

    const handleHideRound = () => {
        setShowRound2(false);
        setCcEmails([]);
        setWhatsAppRoundTwo(false);
        setStop(null);
        setFreq(null);
        setStopby(null);
        setSubject("");
    };


    const removeEmail = (emailToRemove) => {
        setCcEmails(ccEmails.filter((x) => x != emailToRemove));
    };

    const handleHideMail = () => {
        setShowmail(false);
        setCcEmails([]);
        // setHoverTrue(false);
    };

    const handleShowApp = (app) => {


        setEmailContentType(app)

        setMailKey(app)
        if (app == 0) {
            setEmailContent('')
            setShowmail(true);
        } else {
            eclusionMails(app)
            setShowApplication(true);
        }
        htmlContentData(app);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const modules = {
        toolbar: [
            // [{ size: [] }],
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["link"],
            // [{ color: [] }, { background: [] }],
            // ["clean"],
        ],
        clipboard: {
            matchVisual: false,
        },
        // imageResize: {
        //   parchment: Quill.import("parchment"),
        //   modules: ["Resize", "DisplaySize"],
        // },
    };
    const formats = [
        "header",
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "indent",
        "link",
        "image",
        "video",
    ];

    const placeholder = "type here...";


    const handleSendEmail = (event, reson = 0) => {
        console.log(selectsRec);
        console.log("HTML Content:", emailContent);
        const name = event.target.name;
        // setIsSending(true);
        let payload;

        if (mailKey === 1 || mailKey == 4 || mailKey === 5 || mailKey == 6) {

            payload = {
                htmlContent: emailContent,
                ccEmails: ccEmails,
                frequency: Number(freq),
                stopbyAttempts: Number(stop),
                subject: subject,
                whatsAppMessage: whatsApp,
                fromEmail: from,
                stopbyDate: stopby,
                round: mailKey,
            };

            if (mailKey === 1) {
                payload.assmentUsers = mailRecords?.sendTo
                    .map((x) => ({
                        userId: x.userId,
                        codeId: x.id,
                        email: x.emailId,
                        phone: x.phoneNumber,
                    }))
            }

            if (mailKey === 4) {
                payload.assmentUsers = mailRecords?.sendTo
                    .map((x) => ({
                        userId: x.userId,
                        codeId: x.id,
                        email: x.emailId,
                        phone: x.phoneNumber,
                    }))
            }

            if (mailKey === 5 || mailKey === 6) {
                payload.assmentUsers = mailRecords?.sendTo
                    .map((x) => ({
                        userId: x.userId,
                        codeId: x.id,
                        email: x.emailId,
                        phone: x.phoneNumber,
                    }))
            }

        } else if (mailKey === 2) {

            payload = {
                htmlContent: emailContent,
                ccEmails: ccEmails,
                frequency: Number(freq),
                stopbyAttempts: Number(stop),
                subject: subject,
                whatsAppMessage: whatsAppRoundTwo,
                fromEmail: from,
                stopbyDate: stopby,
                round: 2,
                assmentUsers: mailRecords?.sendTo
                    .map((x) => ({
                        userId: x.userId,
                        codeId: x.id,
                        email: x.emailId,
                        phone: x.phoneNumber,
                    })),
            };
        } else if (mailKey === 0) {

            payload = {
                htmlContent: emailContent,
                ccEmails: ccEmails,
                subject: subject,
                fromEmail: from,
                // frequency: Number(freq),
                // stopbyAttempts: Number(stop),
                // stopbyDate: stopby,
                assmentUsers: selectsRec.map((x) => ({
                    userId: x.userId,
                    codeId: x.id,
                    email: x.emailId,
                    phone: x.phoneNumber,
                })),
            };
        } else if (mailKey === 3) {
            payload = {
                htmlContent: emailContent,
                ccEmails: ccEmails,
                subject: subject,
                fromEmail: from,
                whatsAppMessage: whatsAppRej,
                round: 3,
                assmentUsers: selectsRec.map((x) => ({
                    userId: x.userId,
                    codeId: x.id,
                    email: x.emailId,
                    phone: x.phoneNumber,
                })),
            }
        } else if (mailKey === 7) {
            payload = {
                htmlContent: emailContent,
                ccEmails: ccEmails,
                subject: subject,
                fromEmail: from,
                whatsAppMessage: whatsAppRej,
                round: 7,
                assmentUsers: selectsRec.map((x) => ({
                    userId: x.userId,
                    codeId: x.id,
                    email: x.emailId,
                    phone: x.phoneNumber,
                })),
            }
        }
        console.log("Sending Payload:", JSON.stringify(payload));
        console.log(ccEmails);

        handleHideMail();
        handleHideApp();
        handleHideRound();

        if (selectsRec.length > 0 && emailContent) {
            PostCallWithErrorResponse(ApiConfig.SEND_ASSESSMENT_REMINDER, payload)
                .then((res) => {
                    console.log(res);

                    if (res.json.status) {
                        toastMsg("success", res.json.statusMessage);
                        // handleHideMail();
                        // handleHideApp();
                        // handleHideRound();

                        // setEmailContent("");

                        setFreq(null);
                        setStop(null);
                        setStopby(null);
                        handleHideMailTest();
                        handleHideReject();
                        setSelectsRec([]);
                        setSelects([]);
                        // getList(code);
                        setWhatsApp(false);
                        setWhatsAppRej(false);
                        setWhatsAppRoundTwo(false);
                        // setSelectsRec([]);
                    } else {
                        toastMsg("error", res.json.statusMessage);
                    }
                })
                .catch((err) => console.log(err));
            // .finally(() => setIsSending(false));
        } else if (selectsRec.length === 0) {
            toastMsg("error", "please select the Respondents first");
        } else {
            toastMsg("error", "please enter the message");
        }
    };

    return (<>

        <div ref={dropdownRef} style={{ position: "relative", display: "inline-block" }}>
            <Tooltip title="Send Emails">
                <img
                    src={mail1}
                    style={{ cursor: "pointer" }}
                    width={29}
                    height={29}
                    alt="Mail Icon"
                    onClick={() => {
                        if (type === "Job Application") {
                            setOpen((prev) => !prev);
                        } else {
                            handleShowApp(0);
                        }
                    }}
                />
            </Tooltip>

            {open && (
                <ul
                    className="dropdown-menu show"
                    style={{
                        minWidth: "230px",
                        padding: "0",
                        marginTop: "10px",
                        position: "absolute",
                        boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.15)",
                        border: "1px solid #ddd",
                        borderRadius: "6px",
                        overflow: "hidden",
                        zIndex: 1000,
                    }}
                >
                    {mailTypes.map((option, index) => (
                        <li
                            key={index}
                            onClick={() => {
                                handleShowApp(option?.key);
                                setOpen(false); // close on item click
                            }}
                        >
                            <span
                                className="dropdown-item font-size-h4"
                                style={{
                                    padding: "10px 15px",
                                    borderBottom: index !== mailTypes.length - 1 ? "1px solid #eee" : "none",
                                    cursor: "pointer",
                                }}
                            >
                                {option?.label}
                            </span>
                        </li>
                    ))}
                </ul>
            )}
        </div>

        <Modal show={showMail} onHide={handleHideMail} size="lg" dialogClassName="modal-h-650">
            <Modal.Header closeButton className="custom-close-btn">
                <h6 className="mb-0 mt-1">Application</h6>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <Form.Group>
                        <div className="d-flex align-items-center mb-3">
                            <Form.Label className="me-2">Subject</Form.Label>
                            <Form.Control
                                type="text"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                            />
                        </div>
                        <div className="d-flex mt-1">
                            <Form.Label style={{ width: "50px" }}>To</Form.Label>

                            <p>
                                <span>{selects.length}</span> Respondent
                                {selects.length === 1 ? "" : "s"} selected
                            </p>
                        </div>
                    </Form.Group>
                    {from && (
                        <div className="d-flex mt-1">
                            <Form.Label className="me-1" style={{ width: "50px" }}>
                                From
                            </Form.Label>
                            <p>{from}</p>
                        </div>
                    )}
                    <Form.Group>
                        <div className="d-flex align-items-center mb-3">
                            <Form.Label className="me-2" style={{ width: "43px", marginTop: '5px' }}>
                                Cc
                            </Form.Label>
                            <div
                                style={{
                                    flex: 1,
                                    // border: "1px solid #ccc",
                                    // borderRadius: "5px",
                                }}
                            >
                                {ccEmails.map((x, index) => (
                                    <Badge
                                        pill
                                        key={index}
                                        bg="secondary"
                                        className="m-1"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => removeEmail(x)}
                                    >
                                        {x}
                                    </Badge>
                                ))}
                                <Form.Control
                                    type="text"
                                    value={inputValue}
                                    onChange={(e) => setInputValue(e.target.value)}
                                    placeholder="Add email and press enter"
                                    onKeyDown={handleKeyDown}

                                    style={{
                                        border: "none !important",


                                    }}
                                ></Form.Control>
                            </div>
                        </div>
                    </Form.Group>
                    <div style={{ height: "200px" }}>
                        <ReactQuill
                            style={{ height: "170px" }}
                            theme="snow"
                            modules={modules}
                            formats={formats}
                            placeholder={placeholder}
                            defaultValue={emailContent}
                            onChange={setEmailContent}
                        />
                    </div>
                </div>
                <div className="row justify-content-end mt-4">
                    <div className="col-2 d-flex justify-content-end">
                        <button
                            className="border-0 text-white px-3 py-1 rounded-1 btnVldt"
                            name="only email send"
                            onClick={handleSendEmail}
                        >
                            Send
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>

        <Modal show={showApplication} onHide={handleHideApp} size="lg" dialogClassName="modal-h-650">
            <Modal.Header closeButton className="custom-close-btn">
                {/* <h6 className="mb-0 mt-1">{subject}</h6> */}
            </Modal.Header>
            <Modal.Body>
                <div>
                    <Form.Group>
                        <div className="d-flex">
                            <Form.Label className="me-2" style={{ width: "50px" }}>
                                To
                            </Form.Label>
                            <p>
                                {mailRecords?.sendTo?.length} / {mailRecords?.all} Selected
                            </p>
                        </div>
                        <div className="d-flex">
                            <Form.Label className="me-2" style={{ width: "50px" }}>
                                Excl
                            </Form.Label>
                            <p>
                                {mailRecords?.notInrsted} Not Interested,  {mailRecords?.all - mailRecords?.notInrsted - mailRecords?.sendTo.length} {mailRecords.type} Completed
                            </p>
                        </div>

                        {/* <div>
                {
                  selectsRec?.filter(i => i?.c)?.map((i) => {
                    return
                  })
                }
              </div> */}
                        <div className="d-flex align-items-center mb-3">
                            <Form.Label className="me-2">Subject</Form.Label>
                            <Form.Control
                                type="text"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                            />
                        </div>
                        {from && (
                            <div className="d-flex mt-1">
                                <Form.Label className="me-2" style={{ width: "50px" }}>
                                    From
                                </Form.Label>
                                <p>{from}</p>
                            </div>
                        )}
                        {/* <div className="d-flex">
                <Form.Label className="me-2" style={{ width: "50px" }}>
                  To
                </Form.Label>
                <p>
                  All Incomplete Applications
                </p>
              </div> */}
                    </Form.Group>
                    <Form.Group>
                        <div className="d-flex align-items-center mb-3 ">
                            <Form.Label className="me-2" style={{ width: "43px", marginTop: '5px' }}>
                                Cc
                            </Form.Label>
                            <div
                                style={{
                                    flex: 1,
                                    // border: "1px solid #ccc",
                                    // borderRadius: "9px",
                                }}
                            >
                                {ccEmails.map((x, index) => (
                                    <Badge
                                        pill
                                        key={index}
                                        bg="secondary"
                                        className="m-1"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => removeEmail(x)}
                                    >
                                        {x}
                                    </Badge>
                                ))}
                                <Form.Control
                                    type="text"
                                    value={inputValue}
                                    onChange={(e) => setInputValue(e.target.value)}
                                    placeholder="Add email and press enter"
                                    onKeyDown={handleKeyDown}


                                ></Form.Control>
                            </div>
                        </div>
                    </Form.Group>
                    <div style={{ height: "200px" }}>
                        <ReactQuill
                            key={quillKey}
                            style={{ height: "178px" }}
                            theme="snow"
                            defaultValue={emailContent}
                            onChange={(content) => {

                                setEmailContent(content);

                            }}
                            modules={modules}
                            formats={formats}
                            // bounds={"#root"}
                            placeholder={placeholder}
                        />
                    </div>
                </div>
                <div className="row" style={{ marginTop: "50px" }}>
                    {/* <div className="col-3">
              <Form.Group>
                <Form.Label>Reminder Frequency</Form.Label>
                <Form.Select
                  name="freq reminder"
                  id="freq reminder"
                  value={freq}
                  onChange={(e) => setFreq(e.target.value)}
                >
                  <option selected disabled value="">
                    Select frequency
                  </option>
                  <option value={1}>Every Day 1</option>
                  <option value={2}>Every Day 2</option>
                  <option value={3}>Every Day 3</option>
                  <option value={4}>Every Day 4</option>
                  <option value={5}>Every Day 5</option>
                </Form.Select>
              </Form.Group>
            </div>

            <div className="col-3">
              <Form.Group>
                <Form.Label>Stop After</Form.Label>
                <Form.Select
                  name="stop after"
                  id="stop after"
                  value={stop}
                  onChange={(e) => setStop(e.target.value)}
                >
                  <option selected disabled value="">
                    Stop after
                  </option>
                  <option value={1}>1 Attempt</option>
                  <option value={2}>2 Attempt</option>
                  <option value={3}>3 Attempt</option>
                  <option value={4}>4 Attempt</option>
                  <option value={5}>5 Attempt</option>
                  <option value={6}>6 Attempt</option>
                  <option value={7}>7 Attempt</option>
                  <option value={0}>Until job application closed</option>
                </Form.Select>
              </Form.Group>
            </div>
            <div className="col-1">
              <p>(or)</p>
            </div>

            <div className="col-3">
              <Form.Group>
                <Form.Label>Stop By</Form.Label>
                <Form.Control
                  name="stopby"
                  id="stopby"
                  value={stopby}
                  onChange={(e) => setStopby(e.target.value)}
                  type="date"
                ></Form.Control>
              </Form.Group>
            </div> */}

                    {/* <div className="d-flex justify-content-end col-12">
              <button
                className="border-0 text-white px-3 mb-1 py-1 rounded-1 btnVldt w-100"
                style={{ fontSize: "var(--font-size-base)" }}
                name="application send"
                onClick={handleSendEmail}
              // disabled={isSending}
              >
                Send
          
              </button>
              <button
                className="border-0 text-white px-3 py-1 rounded-1 btnVldt w-100"
                style={{ fontSize: "var(--font-size-base)" }}
                name="application send test"
                onClick={handleShowMailTest}
              >
                Test Email
              </button>
             
            </div> */}

                </div>
                <div className="row  " style={{ marginTop: '-10px', marginRight: '-15px' }}>
                    <div className="col-md-8 d-flex mt-1 ml-1 gap-2">
                        <span> Use last sent template</span>

                        <Form.Check
                            checked={isDefaultEmailContent}
                            type="switch"
                            id={"custom-switch"}
                            style={{ marginTop: '-6pX' }}
                            className="custom-switch"
                            onChange={e => {
                                setIsDefaultEmailContent(e.target.checked)
                                htmlContentData(emailContentType, e.target.checked)
                            }}
                        // disabled={isDefaultEmailContent}
                        />
                        <span style={{ marginLeft: '0px' }}>Fetch default template</span>
                    </div>
                    <div className="col-4 d-flex justify-content-end mr gap-1">
                        <button
                            // className="border-0 text-white px-3 py-1 rounded-1 btnVldt w-100 text-base margin-right-2rem"
                            className="btn btn-primary"
                            style={{ width: '90px' }}
                            name="application send test"
                            onClick={handleShowMailTest}
                        >
                            Test Email
                        </button>
                        <button
                            // className="border-0 text-white px-3 py-1 rounded-1 btnVldt w-100 text-base"
                            className="btn btn-primary"
                            name="only email send"
                            onClick={handleSendEmail}
                        >
                            Send
                        </button>
                    </div>
                </div>
            </Modal.Body >
        </Modal >
        <Modal show={showMailTest} centered onHide={handleHideMailTest} size="lg" dialogClassName="modal-h-650">
            <Modal.Header closeButton className="custom-close-btn">
                <h6 className="mb-0 mt-1">Test Email</h6>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <Form.Group>
                        {from && (
                            <div className="d-flex">
                                <Form.Label style={{ width: "50px" }}>From</Form.Label>

                                <p>{from}</p>
                            </div>
                        )}
                    </Form.Group>
                    <Form.Group>
                        <div className="d-flex align-items-center mb-3">
                            <Form.Label className="me-3" style={{ width: "50px", marginTop: '5px' }}>To </Form.Label>
                            <div
                                style={{
                                    flex: 1,
                                    // border: "1px solid #ccc",
                                    // borderRadius: "5px",
                                }}
                            >
                                {toEmails.map((x, index) => (
                                    <Badge
                                        pill
                                        key={index}
                                        bg="secondary"
                                        className="m-1"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => removeEmailTest(x)}
                                    >
                                        {x}
                                    </Badge>
                                ))}
                                <Form.Control
                                    type="text"
                                    value={inputValueTest}
                                    onChange={(e) => setInputValueTest(e.target.value)}
                                    placeholder="Add email and press enter"
                                    onKeyDown={handleKeyDownTest}
                                    className="border-0"
                                // style={{
                                //   border: "none",
                                //   display: "inline-block",
                                //   width: "auto",
                                // }}
                                ></Form.Control>
                            </div>
                        </div>
                    </Form.Group>
                    <div style={{ height: "200px" }}>
                        <ReactQuill
                            key={quillKey}
                            style={{ height: "170px" }}
                            theme="snow"
                            modules={modules}
                            formats={formats}
                            placeholder={placeholder}
                            defaultValue={emailContent}
                            onChange={setEmailContent}
                        />
                    </div>
                </div>
                <div className="row justify-content-end mt-4">
                    <div className="col-2 d-flex justify-content-end">
                        <button
                            // className="border-0 text-white px-3 py-1 rounded-1 btnVldt"
                            className="btn btn-primary"
                            name="only email send"
                            onClick={handleSendEmailTest}
                        >
                            Send
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    </>)

})

export default MailBox